(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hgs-store-locator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var LEAFLET = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/';
  var CLUSTER = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/';
  var REGIONS = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'District of Columbia',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',SK:'Saskatchewan',QC:'Quebec',ON:'Ontario',BC:'British Columbia',AB:'Alberta',VIC:'Victoria',QLD:'Queensland',NSW:'New South Wales'};
  var COUNTRIES = {US:'United States USA',CA:'Canada',AU:'Australia'};
  var ALIASES = {st:'saint',saint:'st',ft:'fort',fort:'ft',mt:'mount',mount:'mt',nyc:'new york',la:'los angeles'};

  function loadCSS(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l);
  }
  function loadJS(src) {
    return new Promise(function (res, rej) {
      var ex = document.querySelector('script[src="' + src + '"]');
      if (ex) { if (ex.dataset.loaded) return res(); ex.addEventListener('load', function () { res(); }); ex.addEventListener('error', rej); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { s.dataset.loaded = '1'; res(); }; s.onerror = rej; document.head.appendChild(s);
    });
  }
  function loadLeaflet() {
    loadCSS(LEAFLET + 'leaflet.min.css'); loadCSS(CLUSTER + 'MarkerCluster.min.css');
    var p = window.L ? Promise.resolve() : loadJS(LEAFLET + 'leaflet.min.js');
    return p.then(function () { return (window.L && window.L.markerClusterGroup) ? null : loadJS(CLUSTER + 'leaflet.markercluster.min.js'); });
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function miles(a, b, c, d) {
    var R = 3958.8, r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
    return 2 * R * Math.asin(Math.sqrt(x * x + Math.cos(a * r) * Math.cos(c * r) * y * y));
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function getJSON(url, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 6000);
    return fetch(url, ctl ? { signal: ctl.signal, headers: { Accept: 'application/json' } } : {}).then(function (r) { clearTimeout(t); if (!r.ok) throw 0; return r.json(); });
  }
  // Geocoding: bundled table first (preview), then free public services.
  function geoZip(zip) {
    var local = window.HGS_GEO && window.HGS_GEO.zip && window.HGS_GEO.zip[zip];
    if (local) return Promise.resolve({ lat: local[0], lng: local[1] });
    return getJSON('https://api.zippopotam.us/us/' + zip).then(function (j) {
      var p = j.places && j.places[0]; return p ? { lat: +p.latitude, lng: +p.longitude } : null;
    }).catch(function () { return geoText(zip + ', USA'); });
  }
  function geoText(q) {
    var key = norm(q), local = window.HGS_GEO && window.HGS_GEO.place && window.HGS_GEO.place[key];
    if (local) return Promise.resolve({ lat: local[0], lng: local[1] });
    var cached = store('hgs-geo:' + key); if (cached) return Promise.resolve(cached);
    return getJSON('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us,ca,au&q=' + encodeURIComponent(q)).then(function (j) {
      if (!j || !j[0]) return null; var p = { lat: +j[0].lat, lng: +j[0].lon }; store('hgs-geo:' + key, p); return p;
    }).catch(function () { return null; });
  }

  function init(root) {
    if (!root || root.__hgs) return; root.__hgs = true;
    var q = function (s) { return root.querySelector(s); };
    var cfg = { radius: +root.dataset.radius || 25, tiles: root.dataset.tiles || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', attr: root.dataset.attr || '&copy; OpenStreetMap contributors' };
    var input = q('[data-hgs-input]'), form = q('[data-hgs-form]'), radiusSel = q('[data-hgs-radius]'), listEl = q('[data-hgs-list]'), statusEl = q('[data-hgs-status]'), mapEl = q('[data-hgs-map]'), clearBtn = q('[data-hgs-clear]'), locBtn = q('[data-hgs-locate]');
    if (radiusSel) radiusSel.value = String(cfg.radius);
    var stores = [], byId = {}, map, cluster, markers = {}, youMarker, activeId = null, current = [], seq = 0;

    function prep(list) {
      list.forEach(function (s, i) {
        if (!s || !s.name) return;
        s.id = s.id || ('s' + i);
        s.lat = s.lat == null || s.lat === '' ? null : +s.lat; s.lng = s.lng == null || s.lng === '' ? null : +s.lng;
        s.country = s.country || 'US';
        s._city = norm(s.city); s._state = norm(s.state); s._name = norm(s.name);
        s._words = norm([s.name, s.address, s.address2, s.city, s.state, REGIONS[(s.state || '').toUpperCase()], s.zip, COUNTRIES[s.country]].join(' ')).split(' ');
        stores.push(s); byId[s.id] = s;
      });
    }
    function readData(doc) { var el = doc.querySelector('[data-hgs-stores]'); try { return JSON.parse(el.textContent); } catch (e) { return []; } }

    function fullAddr(s) { return [s.address, s.address2, s.city, [s.state, s.zip].filter(Boolean).join(' ')].filter(Boolean).join(', '); }
    function dirUrl(s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.name + ', ' + fullAddr(s)); }
    function cardHTML(s) {
      var line1 = esc(s.address) + (s.address2 ? ', ' + esc(s.address2) : '');
      var line2 = esc(s.city) + (s.state ? ', ' + esc(s.state) : '') + (s.zip ? ' ' + esc(s.zip) : '');
      var tel = s.phone ? '<a href="tel:' + esc(s.phone.replace(/[^\d+]/g, '')) + '">' + esc(s.phone) + '</a>' : '';
      var web = s.website ? '<a href="' + esc(s.website) + '" target="_blank" rel="noopener">Website</a>' : '';
      var dist = s._d != null ? '<span class="hgs-sl__dist">' + (s._d < 10 ? s._d.toFixed(1) : Math.round(s._d)) + ' mi</span>' : '';
      return '<li class="hgs-sl__card" tabindex="0" data-id="' + esc(s.id) + '"><div class="hgs-sl__row"><h3 class="hgs-sl__name">' + esc(s.name) + '</h3>' + dist + '</div>' +
        '<address class="hgs-sl__addr">' + line1 + '<br>' + line2 + '</address>' +
        '<div class="hgs-sl__links"><a href="' + dirUrl(s) + '" target="_blank" rel="noopener">Directions</a>' + tel + web + '</div></li>';
    }
    function pinIcon(active) {
      return L.divIcon({ className: 'hgs-sl__pin' + (active ? ' is-active' : ''), iconSize: [30, 43], iconAnchor: [15, 42], popupAnchor: [0, -38],
        html: '<svg viewBox="0 0 30 43" aria-hidden="true"><path d="M15 .6C23 .6 29.4 7 29.4 15c0 2.6-.7 5-1.9 7.2L16.3 41.3a1.5 1.5 0 0 1-2.6 0L2.5 22.2C1.3 20 .6 17.6.6 15 .6 7 7 .6 15 .6z" fill="var(--hgs-pin)" stroke="var(--hgs-pin-edge)" stroke-width="1.2"/><circle cx="15" cy="15" r="6.3" fill="#fff"/></svg>' });
    }
    function popHTML(s) { return '<div class="hgs-sl__pop"><strong>' + esc(s.name) + '</strong>' + esc(fullAddr(s)) + '<br><a href="' + dirUrl(s) + '" target="_blank" rel="noopener">Get directions</a></div>'; }

    function status(html) { statusEl.innerHTML = html; }
    function render(list, msg) {
      current = list;
      listEl.innerHTML = list.length ? list.map(cardHTML).join('') : '<li class="hgs-sl__empty">No stores match that search yet. Try a city, state or zip code, or <a href="#" data-hgs-reset>see all stores</a>.</li>';
      status(msg);
      if (!map) return;
      cluster.clearLayers();
      var ms = list.filter(function (s) { return s.lat != null; }).map(function (s) { return markers[s.id]; });
      cluster.addLayers(ms);
      setActive(null);
    }
    function fit(list, origin) {
      if (!map) return;
      var pts = list.filter(function (s) { return s.lat != null; }).map(function (s) { return [s.lat, s.lng]; });
      if (origin) pts.push([origin.lat, origin.lng]);
      if (!pts.length) return;
      if (pts.length === 1) map.setView(pts[0], 13); else map.fitBounds(pts, { padding: [40, 40], maxZoom: 13 });
    }
    function setActive(id, fromMap) {
      if (activeId && markers[activeId]) markers[activeId].setIcon(pinIcon(false));
      var prev = listEl.querySelector('.is-active'); if (prev) prev.classList.remove('is-active');
      activeId = id; if (!id) return;
      if (markers[id]) markers[id].setIcon(pinIcon(true));
      var card = listEl.querySelector('[data-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
      if (card) { card.classList.add('is-active'); if (fromMap) listEl.scrollTo({ top: card.offsetTop - listEl.offsetTop - 8, behavior: 'smooth' }); }
    }
    function focusStore(id) {
      var s = byId[id]; if (!s) return; setActive(id);
      if (!map || s.lat == null) return;
      cluster.zoomToShowLayer(markers[id], function () { markers[id].openPopup(); });
      if (map.getZoom() < 12) map.setView([s.lat, s.lng], 14);
    }
    function sortDefault(a, b) { return (a.country === b.country ? 0 : a.country === 'US' ? -1 : 1) || (a.state || '').localeCompare(b.state || '') || (a.city || '').localeCompare(b.city || '') || a.name.localeCompare(b.name); }
    function showAll() {
      stores.forEach(function (s) { s._d = null; }); setYou(null);
      var list = stores.slice().sort(sortDefault);
      render(list, '<strong>' + list.length + ' stores</strong> carry Hotgirlsauce. Search to find the closest one.');
      if (map) { var us = list.filter(function (s) { return s.country === 'US'; }); fit(us.length ? us : list); }
    }
    function setYou(p) {
      if (!map) return; if (youMarker) { map.removeLayer(youMarker); youMarker = null; }
      if (p) youMarker = L.marker([p.lat, p.lng], { icon: L.divIcon({ className: 'hgs-sl__you', iconSize: [18, 18] }), keyboard: false, interactive: false }).addTo(map);
    }
    function nearby(p, label) {
      var r = +(radiusSel ? radiusSel.value : cfg.radius);
      var withD = stores.filter(function (s) { return s.lat != null; }).map(function (s) { s._d = miles(p.lat, p.lng, s.lat, s.lng); return s; }).sort(function (a, b) { return a._d - b._d; });
      var within = withD.filter(function (s) { return s._d <= r; }), msg;
      if (within.length) msg = '<strong>' + within.length + ' store' + (within.length > 1 ? 's' : '') + '</strong> within ' + r + ' miles of ' + esc(label);
      else { within = withD.slice(0, 5); msg = 'Nothing within ' + r + ' miles of ' + esc(label) + '. Here are the <strong>closest stores</strong>.'; }
      setYou(p); render(within, msg); fit(within.slice(0, 12), p);
    }
    function textHits(qs) {
      var toks = norm(qs).split(' ').filter(Boolean);
      return stores.filter(function (s) {
        return toks.every(function (t) {
          var alts = [t].concat(ALIASES[t] ? ALIASES[t].split(' ') : []);
          return alts.some(function (a) { return s._words.some(function (w) { return a.length <= 2 ? w === a : w.indexOf(a) === 0; }); });
        });
      });
    }
    function run(raw) {
      var qs = (raw || '').trim(), my = ++seq;
      if (clearBtn) clearBtn.hidden = !qs;
      if (!qs) return showAll();
      var zip = qs.match(/^\d{5}$/);
      if (zip) {
        status('Looking up ' + esc(qs) + '…');
        return geoZip(qs).then(function (p) {
          if (my !== seq) return;
          if (p) return nearby(p, qs);
          var hits = textHits(qs); render(hits, hits.length ? '<strong>' + hits.length + '</strong> in ' + esc(qs) : 'We couldn’t find zip ' + esc(qs) + '.');
          fit(hits);
        });
      }
      var hits = textHits(qs), nq = norm(qs.replace(/,/g, ' '));
      // A city (or "city, ST") query → show everything nearby, not just exact-city matches.
      var cityHits = stores.filter(function (s) { return s.lat != null && (nq === s._city || nq === s._city + ' ' + s._state || nq === s._city + ' ' + norm(REGIONS[(s.state || '').toUpperCase()])); });
      if (cityHits.length) {
        var c = cityHits.reduce(function (a, s) { a.lat += s.lat / cityHits.length; a.lng += s.lng / cityHits.length; return a; }, { lat: 0, lng: 0 });
        return nearby(c, cityHits[0].city + (cityHits[0].state ? ', ' + cityHits[0].state : ''));
      }
      if (hits.length) {
        stores.forEach(function (s) { s._d = null; }); setYou(null);
        hits.sort(sortDefault);
        render(hits, '<strong>' + hits.length + ' store' + (hits.length > 1 ? 's' : '') + '</strong> matching “' + esc(qs) + '”');
        return fit(hits);
      }
      status('Searching near ' + esc(qs) + '…');
      geoText(qs).then(function (p) {
        if (my !== seq) return;
        if (p) nearby(p, qs); else { setYou(null); render([], 'No results for “' + esc(qs) + '”'); }
      });
    }

    // Events
    form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value); });
    var tmr; input.addEventListener('input', function () {
      clearTimeout(tmr); if (clearBtn) clearBtn.hidden = !input.value;
      var v = input.value.trim(); if (!v) return run('');
      if (/^\d{1,4}$/.test(v)) return; // wait for a full zip
      tmr = setTimeout(function () { if (textHits(v).length || /^\d{5}$/.test(v)) run(v); }, 250);
    });
    if (radiusSel) radiusSel.addEventListener('change', function () { if (input.value.trim()) run(input.value); });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; run(''); input.focus(); });
    listEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-hgs-reset]')) { e.preventDefault(); input.value = ''; return run(''); }
      if (e.target.closest('a')) return;
      var c = e.target.closest('[data-id]'); if (c) focusStore(c.dataset.id);
    });
    listEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.dataset && e.target.dataset.id) focusStore(e.target.dataset.id); });
    if (locBtn) locBtn.addEventListener('click', function () {
      if (!navigator.geolocation) return status('Location isn’t available in this browser. Enter a city or zip instead.');
      status('Finding your location…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        input.value = ''; if (clearBtn) clearBtn.hidden = true; seq++;
        nearby({ lat: pos.coords.latitude, lng: pos.coords.longitude }, 'you');
      }, function () { status('We couldn’t get your location. Enter a city or zip instead.'); }, { timeout: 10000, maximumAge: 600000 });
    });

    // Data: first page is inline; more pages (250+ stores) load through Shopify's section rendering.
    prep(readData(root));
    var pages = +root.dataset.pages || 1, base = root.dataset.pageUrl;
    var more = [];
    for (var p = 2; p <= pages && base; p++) more.push(fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + p).then(function (r) { return r.text(); }).then(function (h) { return readData(new DOMParser().parseFromString(h, 'text/html')); }).catch(function () { return []; }));

    showAll();
    Promise.all(more).then(function (lists) {
      lists.forEach(prep);
      return loadLeaflet();
    }).then(function () {
      map = L.map(mapEl, { maxZoom: 19, minZoom: 2, scrollWheelZoom: false, zoomControl: true, worldCopyJump: true }).setView([39.5, -98.35], 4);
      map.on('focus click', function () { map.scrollWheelZoom.enable(); });
      map.on('blur', function () { map.scrollWheelZoom.disable(); });
      if (cfg.tiles !== 'none') L.tileLayer(cfg.tiles, { maxZoom: 19, attribution: cfg.attr }).addTo(map);
      if (window.HGS_BASEMAP) window.HGS_BASEMAP(map);
      cluster = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 45, spiderfyOnMaxZoom: true,
        iconCreateFunction: function (c) { return L.divIcon({ className: 'hgs-sl__cluster', iconSize: [40, 40], html: '<div>' + c.getChildCount() + '</div>' }); } });
      map.addLayer(cluster);
      stores.forEach(function (s) {
        markers[s.id] = L.marker([s.lat == null ? 0 : s.lat, s.lng == null ? 0 : s.lng], { icon: pinIcon(false), title: s.name, alt: s.name }).bindPopup(popHTML(s));
        markers[s.id].on('click', function () { setActive(s.id, true); });
      });
      run(input.value);
      geocodeMissing();
    }).catch(function (e) { if (window.console) console.error('Store locator map:', e); mapEl.innerHTML = '<p class="hgs-sl__empty">The map couldn’t load. The store list still works.</p>'; });

    // Stores saved without coordinates get located from their address (cached per browser).
    function geocodeMissing() {
      var todo = stores.filter(function (s) { return s.lat == null; }), i = 0;
      (function next() {
        var s = todo[i++]; if (!s) return;
        geoText(fullAddr(s)).then(function (p) {
          if (!p && s.zip && s.country === 'US') return geoZip(s.zip);
          return p;
        }).then(function (p) {
          if (p) { s.lat = p.lat; s.lng = p.lng; markers[s.id].setLatLng([p.lat, p.lng]); if (current.indexOf(s) > -1) cluster.addLayer(markers[s.id]); }
          setTimeout(next, 1100);
        });
      })();
    }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-hgs-locator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
